var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Emit, PropSync, Vue, Component } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
let Agent10XModal = class Agent10XModal extends Vue {
    constructor() {
        super(...arguments);
        this.type = '';
        this.channel = '';
        this.message = '';
        this.context = '';
        this.emailSubject = '';
        this.emailProvider = '';
        this.departmentOptions = [
            { checked: false, value: 'Administrativo' },
            { checked: false, value: 'Comercial' },
            { checked: false, value: 'Financeiro' },
            { checked: false, value: 'Gestão' },
            { checked: false, value: 'Industrial' },
            { checked: false, value: 'Jurídico' },
            { checked: false, value: 'Marketing' },
            { checked: false, value: 'Proprietários' },
            { checked: false, value: 'Recursos Humanos' },
            { checked: false, value: 'Saúde' },
            { checked: false, value: 'Suprimento' },
            { checked: false, value: 'TI' },
            { checked: false, value: 'Operacional' },
            { checked: false, value: 'Outros' },
        ];
    }
    closeModal() {
        return;
    }
    async sendCommand() {
        // @ts-ignore
        const valid = await this.$refs.agent10xform.validate();
        if (valid) {
            const message = {
                type: this.type,
                channel: this.channel,
                infosets: this.$route.params.infosetId,
                data: {
                    context: this.context,
                    message: this.message,
                    decisionRole: this.departmentOptions
                        .filter(d => d.checked)
                        .map(d => d.value)
                        .join(', '),
                    subject: this.emailSubject,
                    provider: this.emailProvider,
                },
            };
            console.log(message);
            window.postMessage(message, '*');
        }
    }
};
__decorate([
    PropSync('open', { default: false })
], Agent10XModal.prototype, "showModal", void 0);
__decorate([
    Emit('close')
], Agent10XModal.prototype, "closeModal", null);
Agent10XModal = __decorate([
    Component({
        name: 'Agent10XModal',
        components: { Modal },
    })
], Agent10XModal);
export default Agent10XModal;
